import { useQuery } from "react-query";

import { dropdownValuesService } from "services";

const useAssociationPartnersQuery = () =>
	useQuery("associationPartners", dropdownValuesService.getAssociationPartners);

export default useAssociationPartnersQuery;
